import styled from 'styled-components';

/** The recommended amount: the one number the modal is for. */
export const SuggestedFee = styled.div`
  font-size: 32px;
  font-weight: 700;
  line-height: 1.1;
  color: ${({ theme }) => theme.primary};
`;

export const BulletList = styled.ul`
  margin: 0;
  padding-left: 18px;

  li {
    font-size: 14px;
    line-height: 1.5;
    color: ${({ theme }) => theme.darkGray};

    & + li {
      margin-top: 6px;
    }
  }
`;

/*
 * The order history, one month per row. A grid rather than the shared
 * TableHeader: four short static columns that must stay lined up on a phone,
 * where TableHeader hides itself.
 */
export const MonthRow = styled.div`
  display: grid;
  grid-template-columns: 1.4fr 1fr 1fr 1fr;
  align-items: baseline;
  gap: 8px;
  padding: 8px 0;

  & + & {
    border-top: ${({ theme }) => theme.borders.border1};
  }

  > :not(:first-child) {
    text-align: right;
  }
`;
